import type { Drill } from "./types.ts";
import { taskDependencyResolver } from "./task-dependency-resolver.ts";
import { eventEmitter } from "./event-emitter.ts";
import { promisePool } from "./promise-pool.ts";
import { lruCache } from "./lru-cache.ts";
import { debounceDrill } from "./debounce.ts";
import { retryBackoff } from "./retry-backoff.ts";
import { rateLimiter } from "./rate-limiter.ts";
import { deepEqual } from "./deep-equal.ts";
import { pathAccess } from "./path-access.ts";
import { versionedStore } from "./versioned-store.ts";
import { topKStream } from "./top-k-stream.ts";
import { booleanQueryDepth } from "./boolean-query-depth.ts";
import { interviewScheduler } from "./interview-scheduler.ts";
import { csvEmployeeReport } from "./csv-employee-report.ts";
import { prefixAutocomplete } from "./prefix-autocomplete.ts";

/**
 * The problem bank. Add a drill by writing the file and adding it here.
 *
 * Ids must never change once a drill has been practised: the server's schedule
 * is keyed on them, so renaming one silently starts its history over.
 *
 * Every drill in here is held to the same bar by bank.test.ts: the reference
 * solution passes every case, the untouched starter fails at least one, and
 * every case explains itself.
 */
export const BANK: Drill[] = [
  taskDependencyResolver,
  eventEmitter,
  promisePool,
  lruCache,
  debounceDrill,
  retryBackoff,
  rateLimiter,
  deepEqual,
  pathAccess,
  versionedStore,
  topKStream,
  booleanQueryDepth,
  interviewScheduler,
  csvEmployeeReport,
  prefixAutocomplete,
];

export const byId = (id: string): Drill | undefined => BANK.find((d) => d.id === id);

export type { Drill } from "./types.ts";
